import React = require('react');
import { find, flow, head, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { IAuthState } from '../../../../../../../services/auth/models';
import Carousel, { IcarouselData } from '../../../Carousel';
import AdmIcons from '../../../../../../../components/Icons/AdmIcons';

interface IRenewalPolicy {
  policyId: string;
  auth: IAuthState;
  renewalStatus: string;
  actions: {
    push: (route: string) => any
  }
}

const RenewalPolicy = ({ policyId, auth, renewalStatus, actions }: IRenewalPolicy) => {

  const renewalQuote = find(auth.customer.renewals, ['renewingPolicyId', policyId])

  if (isEmpty(renewalQuote)) {
    return null;
  }

  const hasWaitingListExclusion = renewalQuote.waitingListExclusion;
  const premium = head(renewalQuote.premiums)?.gross?.toFixed(2) || 0;
  const isManual = renewalStatus === 'manual';

  const handleEditRenewal = () => {
    actions.push(`/account/renewals/${renewalQuote.id}`)
  }

  const handleContactUs = () => {
    window.open('https://www.admiral.com/contact-us/travel', '_blank')
  }

  const handleMakeAChange = () => {
    actions.push(`/account/make-a-change/selection/${policyId}`);
  }

  const makeAChange = () => {
    return (
      <div style={{ color: '#0045A0' }} className={'p-carousel-content'} onClick={handleMakeAChange}>
        <div style={{ fontWeight: 'bold' }}>Make a change</div>
        <div style={{ fontSize: '14px' }}>Update travellers, medical and more</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'Admin'} color={'darkBlue'}/>
          <AdmIcons name={'People'} color={'darkBlue'}/>
          <AdmIcons name={'ImportantStatement'} color={'darkBlue'}/>
        </div>
      </div>
    )
  }

  const renewal = () => {
    if (hasWaitingListExclusion) {
      return (
        <div style={{ color: '#FFFFFF' }} className={'p-carousel-content'} onClick={handleContactUs}>
          <div>
            <div><b>Renewal Quote</b></div>
            <div style={{ fontSize: '14px' }}>Contact Us</div>
          </div>
        </div>
      )
    }

    return (
      <div style={{ color: isManual ? '#FFFFFF' : '#0045A0' }} className={'p-carousel-content'} onClick={handleEditRenewal}>
        <div>
          <div><b>{isManual ? 'Click here to renew now' : 'Policy Renewing'}</b></div>
          <div style={{ fontSize: '14px' }}>{isManual ? `£${premium} for 12 months` : 'Ensuring you don\'t lose continuous cover'}</div>
          <div style={{ paddingTop: '10px' }}>
            <AdmIcons name={'People'} color={isManual ? 'white' : 'darkBlue'}/>
            <AdmIcons name={'TravelInsurance'} color={ isManual ? 'white' : 'darkBlue'}/>
            <AdmIcons name={'Tickets'} color={isManual ? 'white' : 'darkBlue'}/>
          </div>
        </div>
      </div>
    )

  }

  const data: IcarouselData[] = [
    {
      component: renewal,
      backgroundColor: isManual || hasWaitingListExclusion ? '#cc0032' : '#e0f2ff',
      navBackGround: isManual ? '#c84c67' : '#b3c1cc'
    },
    { component: makeAChange, backgroundColor: '#e0f2ff', navBackGround: '#b3c1cc' },
  ];

  return (
    <Carousel data={data} animate={true}/>
  )

}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
      }
    }),
  ),
])(RenewalPolicy);
